import { inject, injectable } from '@patsnap/tahiti-core/shared/inversify';
import { GetTaskListRep } from '../task-repository';
import { AbstractTaskServiceImpl } from './abstract-task-service';
import type { TaskRecentService } from '../task-recent-service';

@injectable()
export class TaskRecentServiceImpl extends AbstractTaskServiceImpl implements TaskRecentService {
    constructor(
        @inject(GetTaskListRep)
        private _getTaskListRep: GetTaskListRep,
    ) {
        super();
    }

    public async fetchTaskList() {
        return this._getTaskListRep.fetch({
            page: 1,
            pageSize: 10,
        });
    }
}
